export default __webpack_public_path__ + "static/media/upload.e4cff89b.svg";